import { render, staticRenderFns } from "./CreateSessionPopup.vue?vue&type=template&id=606587f4&scoped=true&"
import script from "./CreateSessionPopup.vue?vue&type=script&lang=js&"
export * from "./CreateSessionPopup.vue?vue&type=script&lang=js&"
import style0 from "./CreateSessionPopup.vue?vue&type=style&index=0&id=606587f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606587f4",
  null
  
)

export default component.exports